"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dateIsExactSameIgnoringMillis(date1, date2) {
    if (date1 === undefined || date2 === undefined) {
        return undefined;
    }
    else {
        return date1.set({ millisecond: 0 }).equals(date2.set({ millisecond: 0 }));
    }
}
exports.dateIsExactSameIgnoringMillis = dateIsExactSameIgnoringMillis;
function dateIsExactSame(date1, date2) {
    if (date1 === undefined || date2 === undefined) {
        return undefined;
    }
    else {
        return date1.equals(date2);
    }
}
exports.dateIsExactSame = dateIsExactSame;
function dateIsAfter(date1, date2) {
    if (date1 === undefined || date2 === undefined) {
        return undefined;
    }
    else {
        return date1 > date2;
    }
}
exports.dateIsAfter = dateIsAfter;
